var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"ui-icon-base component"},_vm.$listeners),[_c(_vm.iconName,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }